module.exports = __webpack_public_path__ + "img/電気回路_5_9_3.51159c95.png";